import { RudderstackTracker } from 'frontend/js/modules/infra/observability/rudderstack/rudderstack';
var RudderstackSink = /** @class */ (function () {
    function RudderstackSink() {
    }
    RudderstackSink.prototype.track = function (event, properties) {
        try {
            RudderstackTracker.getInstance().track(event, properties);
        }
        catch (_) {
            // no-op
        }
    };
    return RudderstackSink;
}());
export { RudderstackSink };
